module.exports = __webpack_public_path__ + "static/media/4560.7a10e680.jpg";